import type { JSX } from 'react';

type PauseIconProps = {
  className?: string;
  variant: 'default' | 'outlined';
};

const PauseIcon = (props: PauseIconProps): JSX.Element => {
  const { className, variant } = props;
  if (variant === 'default') {
    return (
      <svg className={className || ''} viewBox="0 -4 20 31" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2C0 0.89543 0.895431 0 2 0H5.01531C6.11987 0 7.01531 0.895431 7.01531 2V20C7.01531 21.1046 6.11988 22 5.01531 22H2C0.895431 22 0 21.1046 0 20V2ZM12.6276 2C12.6276 0.89543 13.523 0 14.6276 0H17.6429C18.7474 0 19.6429 0.895431 19.6429 2V20C19.6429 21.1046 18.7474 22 17.6429 22H14.6276C13.523 22 12.6276 21.1046 12.6276 20V2Z"
          fill="#F7F8FA"
        />
      </svg>
    );
  }
  if (variant === 'outlined') {
    return (
      <svg
        className={className || ''}
        width="32"
        height="33"
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.65"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9993 4.16663C9.18784 4.16663 3.66602 9.68845 3.66602 16.5C3.66602 23.3115 9.18784 28.8333 15.9993 28.8333C22.8109 28.8333 28.3327 23.3115 28.3327 16.5C28.3327 9.68845 22.8109 4.16663 15.9993 4.16663ZM1.66602 16.5C1.66602 8.58388 8.08327 2.16663 15.9993 2.16663C23.9154 2.16663 30.3327 8.58388 30.3327 16.5C30.3327 24.416 23.9154 30.8333 15.9993 30.8333C8.08327 30.8333 1.66602 24.416 1.66602 16.5Z"
          fill="white"
        />
        <path
          opacity="0.65"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.334 11.5C13.8863 11.5 14.334 11.9477 14.334 12.5V20.5C14.334 21.0523 13.8863 21.5 13.334 21.5C12.7817 21.5 12.334 21.0523 12.334 20.5V12.5C12.334 11.9477 12.7817 11.5 13.334 11.5Z"
          fill="white"
        />
        <path
          opacity="0.65"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.666 11.5C19.2183 11.5 19.666 11.9477 19.666 12.5V20.5C19.666 21.0523 19.2183 21.5 18.666 21.5C18.1137 21.5 17.666 21.0523 17.666 20.5V12.5C17.666 11.9477 18.1137 11.5 18.666 11.5Z"
          fill="white"
        />
      </svg>
    );
  }
  return <></>;
};
export default PauseIcon;
